// extracted by mini-css-extract-plugin
module.exports = {"btn-m":"ButtonM_btn-m__3xOXo"};